import { Form, Radio } from 'antd';
import { useContext } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { OpeningHours } from 'app/typings/core/admin/packs/openingHours/openingHours';
import { OpeningHoursType } from 'app/typings/core/admin/packs/openingHours/openingHours';

import { OpeningHoursConstant } from './OpeningHoursConstant';
import { OpeningHoursDaily } from './OpeningHoursDaily';

const RULES = [{ required: true, message: 'Required' }];

export const OpeningHoursComponent = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance<{
    isDaytime: boolean;
    aliasForUser: string;
    openingHours: OpeningHours;
  }>();
  const formValues = Form.useWatch([], form);

  const openingHoursType = formValues?.openingHours?.type;

  return (
    <SCard title="Opening hours" className="pack-form">
      <FormLineLayout label="Start time / End time" labelOnTop isRequired>
        <div className="pack-opening-hours-wrapper">
          <Form.Item
            initialValue={OpeningHoursType.CONSTANT}
            name={['openingHours', 'type']}
            rules={RULES}
            noStyle
          >
            <Radio.Group disabled={!isEditMode}>
              <Radio value={OpeningHoursType.CONSTANT}>Same every day</Radio>
              <Radio value={OpeningHoursType.DAILY} disabled={true}>
                Depends on the day
              </Radio>
            </Radio.Group>
          </Form.Item>

          {openingHoursType === OpeningHoursType.CONSTANT && (
            <OpeningHoursConstant />
          )}
          {openingHoursType === OpeningHoursType.DAILY && <OpeningHoursDaily />}
        </div>
      </FormLineLayout>
    </SCard>
  );
};
